import { render, staticRenderFns } from "./ZoomableImage.vue?vue&type=template&id=765efdd1&"
import script from "./ZoomableImage.vue?vue&type=script&lang=js&"
export * from "./ZoomableImage.vue?vue&type=script&lang=js&"
import style0 from "./ZoomableImage.vue?vue&type=style&index=0&id=765efdd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports